export default "__VITE_ASSET__dPT$FIYw__"